export const scoreview = {
    path: '/score',
    name: 'score',
    title: '概览',
    component: () => import("../components/page/score/index"),
    children: [
      {
        path: '/qualityList',
        name: 'qualityList',
        component: () => import("../components/page/score/qualityList"),
        meta: { title: '品质管理' },
      },
      {
        path: '/qualityAdd',
        name: 'qualityAdd',
        component: () => import("../components/page/score/qualityList"),
        meta: { title: '新增品质' },
      },
      {
        path: '/stList',
        name: 'stList',
        component: () => import("../components/page/score/standardList"),
        meta: { title: '标准管理' },
      },
      {
        path: '/stInfo',
        name: 'stInfo',
        component: () => import("../components/page/score/standardInfo"),
        meta: { title: '新增标准' },
      },
      {
        path: '/specimenList',
        name: 'specimenList',
        component: () => import("../components/page/score/specimenList"),
        meta: { title: '样品管理' },
      },
      {
        path: '/specimenAdd',
        name: 'specimenAdd',
        component: () => import("../components/page/score/specimenAdd"),
        meta: { title: '新增样品' },
      },
      {
        path: '/statisticsList',
        name: 'statisticsList',
        component: () => import("../components/page/score/statisticsList"),
        meta: { title: '统计得分' },
      } ,{
        path: '/statisticsInfo',
        name: 'statisticsInfo',
        component: () => import("../components/page/score/statisticsInfo"),
        meta: { title: '统计详情' },
      },
      {
        path: '/scoreEventList',
        name: 'scoreEventList',
        component: () => import("../components/page/score/scoreEventList"),
        meta: { title: '评分事件管理' },
      } ,{
        path: '/scoreEventInfo',
        name: 'scoreEventInfo',
        component: () => import("../components/page/score/scoreEventInfo"),
        meta: { title: '新增评分' },
      }
      ,{
      //   path: '/scoreEventSpecimen',
      //   name: 'scoreEventSpecimen',
      //   component: () => import("../components/page/score/scoreEventSpecimen"),
      //   meta: { title: '评价样品' },
      // } ,{
        path: '/specimenTestInfo',
        name: 'specimenTestInfo',
        component: () => import("../components/page/score/specimenTestInfo"),
        meta: { title: '新增检测' },
      } ,{
        path: '/specimenTestList',
        name: 'specimenTestList',
        component: () => import("../components/page/score/specimenTestList"),
        meta: { title: '检测结果' },
      },{
        path: '/scoreDataList',
        name: 'scoreDataList',
        component: () => import("../components/page/score/scoreDataList"),
        meta: { title: '用户评分' },
      } ,{
        path: '/scoreDataInfo',
        name: 'scoreDataInfo',
        component: () => import("../components/page/score/scoreDataInfo"),
        meta: { title: '用户评分' },
      }
    ]
  };



// WEBPACK FOOTER //
// ./src/router/score.js